/**
 * How a finger number is drawn on every play surface: the typeface and the size, in staff line
 * gaps, Sight Reading draws them with. Each surface places its numbers clear of the staff lines,
 * the right hand's above and the left hand's below.
 */
export const FINGER_NUMBER_FONT_FAMILY = 'Times New Roman';

/** A finger number's height, in line gaps (the distance between two staff lines). */
export const FINGER_NUMBER_SIZE_LINE_GAPS = 1.25;

/** The font size of a finger number on a staff whose lines are `lineGap` apart. */
export const fingerNumberFontSize = (lineGap: number): number => {
  if (!(lineGap > 0)) {
    throw new Error(`fingerNumberFontSize: a line gap must be positive (got ${lineGap})`);
  }
  return lineGap * FINGER_NUMBER_SIZE_LINE_GAPS;
};
